
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import { mapState } from 'vuex'

export default {
name: 'info',
props: ['lastDataObj'],
components: {
Group,
Cell,
PopupPicker,
XInput,
XTextarea,
XHeader,
XButton,
CheckIcon
},
data () {
return {
readNotice: false,
id: '',
btnTextSave: '',
infoList: [],
fromItem: [
{
name: '缓交类型：',
type: 'select',
data: [[' ']],
value: [],
id: '',
max: ''
},
{
name: '申请金额：',
type: 'text',
max: '',
value: 0
},
{
name: '申请原因：',
type: 'textarea',
max: 40,
value: ''
}
],
loanInfo: [
{
name: '缓交类型',
label: '缓交类型',
value2: [],
value: '',
id: ''
},
{
name: '申请金额',
label: '申请金额',
value: '',
max: 0
},
{
name: '申请原因',
label: '申请原因',
value: ''
}
],
termText: '',
disabledEditMoney: false,
isEdit: 0,
lastTypeId: '',
lastApplyMoney: ''
}
},
computed: {
...mapState({
token: state => state.token,
studentId: state => state.userInfo.id,
flowId: state => state.flowInfo.flowId,
flowType: state => state.flowInfo.flowType,
title: state => state.currentProcedureInfo.name,
flowProcedureId: state => state.currentProcedureInfo.flowProcedureId,
procedureId: state => state.currentProcedureInfo.procedureId,
endDate: state => state.currentProcedureInfo.endDate,
flowYear: state => state.flowInfo.flowYear,
parentRouter: state => state.currentProcedureInfo.parentRouter
}),
btndisabled () {
let flag = true
if (this.loanInfo[2].value === '') {
flag = true
} else {
flag = false
}
return flag
}
},
created () {},
mounted () {
this.getLastData()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {

this.$router.push({
name: this.parentRouter
})
}, 300)
},
onShow () {
},
onHide (closeType) {
if (closeType === true) {
this.onBlur()
}
},

submitForm () {
let params = {
'id': this.id,
'studentId': this.studentId,
'flowId': this.flowId,
'flowProcedureId': this.flowProcedureId,
'procedureId': this.procedureId,
'greenchanneltypeId': 1,
'status': 1,
'applyMoney': 0,
'checkMoney': '',
'handdlerType': 0,
'handler': '',
'remark': this.loanInfo[2].value,
'fileIds': ''
}
this.$api.post('/sdtskjxy/greenChannel/handle', params,
r => {
this.$router.push({name: 'itemResult'})
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getLastData () {
let params = {
'studentId': this.studentId,
'flowId': this.flowId,
'procedureId': this.procedureId
}
this.$api.get('greenChannel', params,
r => {
if (r.data) {
this.id = r.data.id
this.btnTextSave = '重新申请'
this.loanInfo[2].value = r.data.remark
} else {
this.btnTextSave = '申请'
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/loan.vue